import { all, put, takeEvery } from 'redux-saga/effects';
import * as actionTypes from '../actions/ActionTypes';
import * as api from '../../shared/services/api/apiAchievement';
import {
  OFFLINE_USER,
  SESSION_EXPIRED,
  SESSION_EXPIRED_CODE,
  SOMETHING_WRONG,
} from '../../shared/constants/Constants';
import { Logout, startLoading, stopLoading, updateAchievementDetails } from '../actions';
import { checkOffline } from '../../shared/services/Utility';

function* SubmitAchievementDetails(action) {
  try {
    let res = yield api.setAchievementAPI(action.data);
    if (res.status === 1) {

    }
  } catch (e) {
  }
}

function* fetchTheAchievementDetails(action) {
  yield put(startLoading());
  try {
    let res = yield api.fetchAchievementDetails(action.params);
    if (res.status === 1) {
      //data fetched
      // alert(res.data)
      yield put(updateAchievementDetails(res.data));
      yield put(stopLoading());
    } else if (res.status === 0) {
      yield put(
        updateAchievementDetails([
          {
            achievement_type: 'null_achievement',
            status: '1',
          },
        ]),
      );
      yield put(stopLoading());
    } else if (res.status === SESSION_EXPIRED_CODE) {
      /*session id expired*/
      // if (!Utility.isAlertShowing) {
      //   Utility.updateAlertShowing(true);
      //   Alert.alert(APP_NAME, SESSION_EXPIRED, [
      //     {
      //       text: "OK",
      //       onPress: () => {
      //         Utility.updateAlertShowing(false);
      //       }
      //     }
      //   ]);
      //   yield put(Logout());
      //   // yield put(goto_login())
      // }

      yield put(stopLoading());
      action.callback(SESSION_EXPIRED, 'error');
      yield put(Logout());
    }
  } catch (e) {
    yield put(stopLoading());
    if (checkOffline()) {
      action.callback(OFFLINE_USER, 'error');
    } else {
      action.callback(SOMETHING_WRONG, 'error');
    }
  }
}

function* AchievementSaga() {
  yield all([
    takeEvery(actionTypes.UNLOCK_ACHIEVEMENT, SubmitAchievementDetails),
    takeEvery(
      actionTypes.FETCH_ACHIEVEMENT_DETAILS,
      fetchTheAchievementDetails,
    ),
  ]);
}

export default AchievementSaga;
